<template>
  <article class="edu">
    <header class="edu__head">
      <div class="edu__titles">
        <h3 class="edu__degree">{{ degree }}</h3>
        <p class="edu__school">{{ school }}</p>
      </div>
      <time class="edu__dates">
        <template v-if="from && to">{{ from }} — {{ to }}</template>
        <template v-else>{{ year }}</template>
      </time>
    </header>
  </article>
</template>

<script>
export default {
  name: 'Education',
  props: {
    degree: String,
    school: String,
    from: String,
    to: String,
    year: String
  }
}
</script>

<style scoped>
.edu__head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.5rem 1.5rem;
}

.edu__degree {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: -0.015em;
  line-height: 1.25;
  color: var(--ink);
}

.edu__school {
  margin: 0.2rem 0 0;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--accent);
}

.edu__dates {
  flex-shrink: 0;
  font-family: var(--font-mono);
  font-size: 0.8rem;
  color: var(--ink-muted);
  font-style: normal;
  padding-top: 0.2rem;
}

@media (max-width: 560px) {
  .edu__dates {
    width: 100%;
  }
}
</style>
